import { updateWidgetValue } from '@/services/api/widgets';

export const activationCommand = (workspaceId, widget, status) => {
  if (status == 'true') updateWidgetValue(workspaceId, widget, Number(true));
  else updateWidgetValue(workspaceId, widget, Number(false));
};
